import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const datepickerDropdownFn = /* @__PURE__ */ createRecipe('datepicker-dropdown', {}, [])

const datepickerDropdownVariantMap = {}

const datepickerDropdownVariantKeys = Object.keys(datepickerDropdownVariantMap)

export const datepickerDropdown = /* @__PURE__ */ Object.assign(memo(datepickerDropdownFn.recipeFn), {
  __recipe__: true,
  __name__: 'datepickerDropdown',
  __getCompoundVariantCss__: datepickerDropdownFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: datepickerDropdownVariantKeys,
  variantMap: datepickerDropdownVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, datepickerDropdownVariantKeys)
  },
  getVariantProps: datepickerDropdownFn.getVariantProps,
})